import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#001a2d] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🎾 ¿QUÉ AGREGA EL{' '}
            <span className="text-[#00B4D8]" data-id="element-78">PÁDEL PRO BUSINESS™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            Tu sistema de cobro, captación e identidad profesional. Porque las
            clases que das ya son extraordinarias. Este sistema hace que tu
            negocio lo sea también.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d1a] border-b border-[#00B4D8]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00B4D8]/30" data-id="element-83">
              Sin Pádel Pro Business
            </div>
            <div className="p-4 font-bold text-[#00B4D8] text-center border-l border-[#00B4D8]/30" data-id="element-84">
              Con Pádel Pro Business
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              Tu cobro
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Pádel Pro Business:
              </span>
              Por clase, irregular
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-91">
                Con Pádel Pro Business:
              </span>
              Abono mensual el día 1-5
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Cancelaciones
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Pádel Pro Business:
              </span>
              Sin política clara
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-98">
                Con Pádel Pro Business:
              </span>
              Reglamento firmado
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              Ingresos
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Pádel Pro Business:
              </span>
              Impredecibles
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-105">
                Con Pádel Pro Business:
              </span>
              Fijos desde el día 5
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              Nuevos alumnos
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Pádel Pro Business:
              </span>
              Solo boca a boca
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-112">
                Con Pádel Pro Business:
              </span>
              Sistema de referidos activo
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-113">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-115">
                Situación:
              </span>
              Clínicas
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-116">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-117">
                Sin Pádel Pro Business:
              </span>
              No las hacés
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-118">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-119">
                Con Pádel Pro Business:
              </span>
              1 sábado = lo que ganás en semana
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-120">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-121">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-122">
                Situación:
              </span>
              Tu Instagram
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-123">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-124">
                Sin Pádel Pro Business:
              </span>
              Sin estrategia
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-125">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-126">
                Con Pádel Pro Business:
              </span>
              30 días de contenido listo
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-127">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-128">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-129">
                Situación:
              </span>
              El alumno que falta
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-130">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-131">
                Sin Pádel Pro Business:
              </span>
              Sin sistema
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-132">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-133">
                Con Pádel Pro Business:
              </span>
              Protocolo de re-enganche
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-134">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-135">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-136">
                Situación:
              </span>
              Tu precio
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-137">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-138">
                Sin Pádel Pro Business:
              </span>
              El del mercado o menos
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-139">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-140">
                Con Pádel Pro Business:
              </span>
              30-50% más justificado
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-141">
          ✅ PÁDEL PRO BUSINESS™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-142">
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-143">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-144">
              💰 Bloque 1 — El Abono Blindado
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-145">
              Cómo pasar del cobro por clase al abono mensual adelantado sin
              perder un solo alumno. Incluye: Reglamento de Cancelaciones +
              Contrato Ético de Alumno listos para usar.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-146">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-147">
              🎾 Bloque 2 — Fábrica de Clínicas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-148">
              El modelo de clínica de 3 horas que te genera lo equivalente a 15
              horas de clase individual. Incluye: Estructura completa + Cómo
              llenarla sin gastar un peso + Flyer editable en Canva.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-149">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-150">
              📱 Bloque 3 — WhatsApp que Vende
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-151">
              Scripts exactos para convertir interesados en alumnos fijos en 3
              mensajes. Incluye: Sistema de venta + Manejo de objeciones +
              Sistema de referidos automático.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-152">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-153">
              📸 Bloque 4 — Marketing Cero Gasto
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-154">
              Cómo usar tus clases actuales para filmar contenido que te llene
              la agenda. Incluye: Los 20 tipos de post que atraen alumnos +
              Calendario de 30 días listo.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5 md:col-span-2" data-id="element-155">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-156">
              📊 Assets incluidos:
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-157">
              Planilla de Caja Profe · Calculadora de Precio Justo · Reglamento
              de Cancelaciones · Contrato Ético · Flyer Editable · Pack de 20
              Stories para Instagram
            </p>
          </div>
        </div>
      </div>
    </section>;
}